export default __webpack_public_path__ + "static/media/cross.993527ed.svg";